import { render, staticRenderFns } from "./ChinaCityTableMobile.vue?vue&type=template&id=03670b1c&scoped=true&"
import script from "./ChinaCityTableMobile.vue?vue&type=script&lang=js&"
export * from "./ChinaCityTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./ChinaCityTableMobile.vue?vue&type=style&index=0&id=03670b1c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03670b1c",
  null
  
)

export default component.exports